module.exports = __webpack_public_path__ + "static/media/roles_and_permission.66f4a585.svg";